import {gql} from "@irati/utils/gql"

const query = gql`
  query ScheduledTransfers(
    $walletOwnerId: String!
    $walletId: String!
    $scheduledTransferStatus: [ScheduledTransferStatus]
    $cursor: String
    $limit: Int
  ) {
    scheduledTransfers(
      walletOwnerId: $walletOwnerId
      walletId: $walletId
      scheduledTransferStatus: $scheduledTransferStatus
      cursor: $cursor
      limit: $limit
    ) {
      cursor
      limit
      count
      offset
      results {
        uuid
        amount
        status
        createdAt
        captureAt
        sourceWallet
        destinationWallet
        perksGO {
          image
          title
          type
          location
          transactionAmount
          lastFour
          dealHeader
          dealUrlSlug
          dealUuid
          transactionDate
          savingPercent
          isPerksGoRetailDeal
        }
      }
    }
  }
`

export const toString = query.loc.source.body

export default query
